// extracted by mini-css-extract-plugin
module.exports = {"content":"SeeReviews_content__mBHlK"};